// Display helpers — all dates/times rendered in the venue timezone (NZ).
const TZ = "Pacific/Auckland";

export const nzd = (n: number | string) =>
  new Intl.NumberFormat("en-NZ", { style: "currency", currency: "NZD" }).format(Number(n));

// am/pm per owner feedback 2026-06-12 (customers shouldn't read 24h time).
export const nzTime = (iso: string) =>
  new Intl.DateTimeFormat("en-NZ", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: TZ,
  }).format(new Date(iso));

export const nzDateLong = (iso: string) =>
  new Intl.DateTimeFormat("en-NZ", {
    weekday: "long",
    day: "numeric",
    month: "long",
    timeZone: TZ,
  }).format(new Date(iso));

export const nzDateShort = (iso: string) =>
  new Intl.DateTimeFormat("en-NZ", {
    weekday: "short",
    day: "numeric",
    month: "short",
    timeZone: TZ,
  }).format(new Date(iso));

// Today's date (YYYY-MM-DD) in NZ — the default booking date.
export const todayNZ = () => {
  const parts = new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    timeZone: TZ,
  }).format(new Date());
  return parts; // en-CA gives YYYY-MM-DD
};

// Standardised guest-count descriptor, used app-wide (booking flow, checkout,
// confirmation, manage, staff console) — "2 adults · 1 child" /
// "2 adults · 2 children". Mirrors the email {{party_summary}} variable
// (lib/comms/engine.ts) so every surface reads identically. Children are only
// appended when present.
export const partySummary = (adults: number, children: number) => {
  const parts = [`${adults} adult${adults === 1 ? "" : "s"}`];
  if (children > 0) parts.push(`${children} ${children === 1 ? "child" : "children"}`);
  return parts.join(" · ");
};

// Customer-facing product name for a booking. The Remarkables is an exclusive hire
// of The Commons, so it is stored against that pool and its resource name reads "The
// Commons" — correct for the communal product, wrong for the premium one. Every
// customer surface (checkout, confirmation, .ics, pay link, agent portal, manage)
// resolves the label here so they can't drift apart. Emails deliberately do NOT use
// this: they render {{category_name}} (lib/comms/engine.ts), which says "Remarkables"
// without the article because it sits mid-sentence ("your Remarkables booking").
export const REMARKABLES_PRODUCT_NAME = "The Remarkables";

export const bookingProductName = (
  bookingKind: string | null | undefined,
  resourceName: string | null | undefined,
) => (bookingKind === "remarkables" ? REMARKABLES_PRODUCT_NAME : resourceName ?? "");

// Add days to a YYYY-MM-DD string (date-only arithmetic).
export const addDays = (ymd: string, n: number) => {
  const d = new Date(`${ymd}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
};
